import {pipeHandlers} from 'utils/reduxEffects';
import common from './common/handler';
import listViewPage from './listViewPage/handler';

export default pipeHandlers(common, listViewPage);
